import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ChartView from '../containers/chartView'
import { Typography } from '@mui/material';


const PREFIX = 'Home';

const classes = {
    root: `${PREFIX}-root`,
    options: `${PREFIX}-options`,
    principal: `${PREFIX}-principal`,
    rightToolbar: `${PREFIX}-rightToolbar`,
    appBar: `${PREFIX}-appBar`,
    toolBar: `${PREFIX}-toolBar`
};

const StyledThemeProvider = styled('div')({
    [`& .${classes.root}`]: {
        flex: 1,
        backgroundColor: '#f5f5f5',
        height:'100%',
        //height: '100vh',
        maxWidth: '100%',
        //overflowY:'scroll',
        //overflowX:'hidden',
    },
    [`& .${classes.options}`]: {
        paddingLeft: '15px',
        paddingRight: '15px',
        paddingTop: '5px',
        paddingBottom: '35px',
        marginRight: '10px',
        marginTop: '0px',
        marginBottom: '10px',
        maxWidth: '100%',
        height: `calc(100vh - 130px)`
    },
    [`& .${classes.principal}`]: {
        paddingBottom: '40px',
        marginLeft: '10px',
        marginRight:'10px',
        marginTop: '10px',
        marginBottom: '10px',
        maxWidth: '100%',
        //height: '100%',
        height: `calc(100vh - 100px)`
        //height: 'calc(100% - 40px)'
    },
    [`& .${classes.rightToolbar}`]: {
        marginLeft: 'auto',
        marginRight: -12,
    },
    [`& .${classes.appBar}`]: {
        color:'white'
    },
    [`& .${classes.toolBar}`]: {
        minHeight:'40px',
    }
});


function Home(props) {
    const {
        theme, 
        timeout, 
        logout, 
        //chartsList
        chartConfig
    } = props;

    return (
        <StyledThemeProvider theme={theme}>
            <div className={classes.root}>
                <AppBar position="fixed" style={{ background: theme.palette.primary.mainGradient }} className={classes.appBar}>
                    <Toolbar className={classes.toolBar} variant="dense">
                        <Typography variant='subtitle2' >
                        {'>'} Bienvenidos a ClasS Web Platform | Sistema de análisis estadísticos ClasS
                        </Typography>
                        
                        <section className={classes.rightToolbar}>
                            <Button
                                variant="outlined"
                                color="inherit"
                                size="small"
                                style={{ float: "right" }}
                                onClick={logout}
                            >
                                Cerrar sesión
                        </Button>
                        </section>
                    </Toolbar>

                </AppBar>
                <Toolbar className={classes.toolBar} />
                <Grid container>
                    <Grid item xs={12}>
                        {/*<Paper className={classes.principal}>*/}
                        <div className={classes.principal}>
                            {/*Vista gráficos y filtros*/}
                            <ChartView 
                                timeout = {timeout}
                                //chartsList = {chartsList}
                                chartConfig ={chartConfig}
                            />

                        </div>
                        {/*</Paper>*/}
                    </Grid>
                </Grid>
            </div>

        </StyledThemeProvider>
    );
}

export default Home;